var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "global-container",
      staticStyle: { position: "fixed", top: "0px" }
    },
    [
      _c("div", { staticClass: "message-container" }, [
        _vm._v(_vm._s(_vm.message))
      ]),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner-container" }, [
      _c("img", {
        attrs: { alt: "en attente", src: "/assets/images/spinners/crepe-o.gif" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }